'use client'
import AdsCard from '@/components/Cards/AdsCard'
import { Heading, TabContent, TabWrapper } from '@/components/Common'
import { useClassifieds } from '@/hooks/useClassifieds'
import React from 'react'
import { HeaderProps } from '../Header/Header'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import Image from 'next/image'
import { Autoplay } from 'swiper/modules'

const AdsSection = ({ menus = [] }: HeaderProps) => {
  const { allClassifieds, isLoading } = useClassifieds({
    size: 20,
  })

  return (
    <section className="container mt-4">
      <div className="grid grid-cols-12 gap-4 overflow-hidden">
        {/* Left Column */}
        <div className="col-span-12 lg:col-span-8 space-y-5">
          {menus
            .filter((menu) => menu.childCategories?.length > 0) // Lọc menu có childCategories
            .map((menu) => (
              <TabWrapper key={menu.id} categories={menu}>
                {(activeTab) => <TabContent slug={activeTab} />}
              </TabWrapper>
            ))}
        </div>

        {/* Right Column */}
        <div className="col-span-12 lg:col-span-4">
          <Heading>Rao vặt</Heading>
          <div className="overflow-y-auto max-h-[600px] mb-5">
            {/* Hiển thị trạng thái loading */}
            {isLoading
              ? Array.from({ length: 10 }).map((_, index) => <AdsCard key={index} isLoading />)
              : allClassifieds.map((ad) => (
                  <AdsCard
                    key={ad.id} // Sử dụng id để làm key
                    imageUrl={ad.imageUrl} // Dùng ảnh mặc định nếu không có
                    date={ad.publishDate} // Ngày đăng
                    title={ad.title} // Tiêu đề
                    link={ad.slug} // Link
                  />
                ))}
          </div>
          <Swiper
            className="mb-5"
            modules={[Autoplay]}
            spaceBetween={10} // Khoảng cách giữa các slide
            slidesPerView={1} // Chỉ hiển thị một slide mỗi lần
            loop
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={false} // Ẩn pagination (chấm tròn)
            navigation={false} // Ẩn các nút next/prev
          >
            <SwiperSlide>
              <article className="w-full h-auto relative">
                <Link href="/" rel="noopener noreferrer">
                  <Image
                    src="/Image/Tai_ung_dung_1000x380px_1.jpg"
                    alt="Tai_ung_dung_1000x380px"
                    width={300}
                    height={300}
                    className="object-cover"
                    layout="responsive"
                  />
                </Link>
              </article>
            </SwiperSlide>
            <SwiperSlide>
              <article className="w-full h-auto relative">
                <Link href="/" rel="noopener noreferrer">
                  <Image
                    src="/Image/Tai_ung_dung_1000x380px_2.jpg"
                    alt="Tai_ung_dung_1000x380px"
                    width={300}
                    height={300}
                    className="object-cover"
                    layout="responsive"
                  />
                </Link>
              </article>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>
  )
}

export default AdsSection
